<h2 mat-dialog-title>
  Afslagsbrev
  <mat-divider></mat-divider>
</h2>
<mat-dialog-content>
  <p>Afslagsbrev gør det muligt for fonden at printe et papirafslag til ansøger. Selve afslagsskabelonen konfigureres seaprat med fondens brevhoved.</p>
  <form [formGroup]="form">
    <mat-form-field>
      <mat-label>Skabelon</mat-label>
      <input
        type="text"
        matInput
        formControlName="template"
        >
      <mat-hint>Indtast nøglen til afslagsskabelonen.</mat-hint>
      @if (template.hasError('required')) {
        <mat-error><strong>Skal</strong> udfyldes.</mat-error>
      }
      @if (template.hasError('maxlength')) {
        <mat-error><strong>Højst</strong> 100 tegn.</mat-error>
      }
    </mat-form-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button mat-dialog-close>Luk</button>
  <button mat-flat-button (click)="doSave()" [disabled]="form.invalid">Gem</button>
</mat-dialog-actions>
